import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { compose } from "redux";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";

import { setA11yContent } from "../../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions";

import Header from "common-components/Header";
import { TitleLockup } from "@vds/type-lockups";
import { isMobile } from "utils/style";
import Button from "common-components/Buttons";
import Container from "common-components/Container";

import FetchPageContent from "../../../../hoc/FetchPageContent";

class AuthorizedAgentDownloadInformation extends Component {
  componentDidMount() {
    if (checkNestedObject(this.props.breadCrumbs, "landingPage")) {
      const { landingPage, customerHistory, informationRequest, downloadRequest } = this.props.breadCrumbs;
      this.props.setBreadcrumbList([
        { label: landingPage, path: "/privacy/secure/authorized-agent" },
        { label: customerHistory, path: "/privacy/secure/authorized-agent/customer" },
        { label: informationRequest, path: "/privacy/secure/authorized-agent/new-request" },
        { label: downloadRequest, path: "/privacy/secure/authorized-agent/download" }
      ]);
    }

    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("download information", this.props.pageContent.sc_pagetitle);
    }
  }

  handleClick = () => {
    this.props.history.push({
      pathname: "multifactor-authentication-primer",
      state: {
        confirmAuth: true,
        // nextRoute: "/privacy/secure/authorized-agent/download/affidavit",
        nextRoute: "/privacy/secure/authorized-agent/request-download",
        customerHistory: this.props.agentCustomerHistory
      }
    });
  };

  render() {
    if (!checkNestedObject(this.props, "pageContent", "section_title")) {
      return <Redirect to="/privacy/secure/authorized-agent" />;
    }
    const { section_title, section_description, buttons } = this.props.pageContent;

    return (
      <Container>
        <div style={{ maxWidth: "596px" }}>
          {/* DPCMP - 3792, 3791*/}
        <TitleLockup 
              surface= 'light'
              textAlignment= 'left'
              viewport={isMobile ? "mobile": "desktop"}
              data={{
                 title:{
                  size:'titleLarge',
                  bold: true,
                  children: convertStringToElements(section_title)
                 },
                 subtitle:{
                    size: 'bodyLarge',
                    primitive:'p',
                    children: <Div> {convertStringToElements(section_description)} </Div>
                    }

               }}
            
            
        />
          {/* <Header>{convertStringToElements(section_title)}</Header>
          <Div>{convertStringToElements(section_description)}</Div> */}

          <Button background={buttons[0].type} style={{ marginTop: "16px" }} onClick={this.handleClick}>
            {buttons[0].text}
          </Button>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = ({ pageContent: { download_information: pageContent, breadCrumbs }, agentCustomerHistory }) => ({
  pageContent,
  breadCrumbs,
  agentCustomerHistory
});

export default compose(
  connect(
    mapStateToProps,
    { setA11yContent, setBreadcrumbList }
  ),
  FetchPageContent
)(AuthorizedAgentDownloadInformation);

const Div = styled.div`
  margin: 40px 0;

  p {
    margin: 12px 0;
  }
`;
